import React from 'react';
import { useLocationUsersAdminPanel } from '../../../../hooks/useLocationUsersAdminPanel';
import { LocationAdmins } from './LocationAdmins';

/**
 * The office profile's Location Admins tab, behind the GOTU-7482 Location
 * Users flag.
 *
 * The branch sits above `LocationAdmins` so that with the flag off no
 * organization-service request goes out at all; its data hooks cannot be
 * called conditionally. Flag off renders nothing rather than redirecting:
 * PostHog answers `false` until its flags arrive, so a redirect would bounce a
 * flag-on admin who deep-linked here before they landed. `DNTTabs` hides the
 * tab on the same flag.
 */
export const LocationAdminsTabScreen = () => {
  const isEnabled = useLocationUsersAdminPanel();

  return isEnabled ? <LocationAdmins /> : null;
};

export default LocationAdminsTabScreen;
